import React from 'react';
import { navigate } from '@reach/router';
import PropTypes from 'prop-types';
import LoginPage from '../../components/LoginPage/LoginPage';

const VOIE = (props) => {
 
  // Instantiate constant with Host API connection
  const host = props.host;

  const onSuccessLogin = (transactionId) => {
    if (transactionId) {
      navigate(`/voie/details/${transactionId}`);
    } else {
      navigate('/voie/order');
    }
  };

  return (
    <VoiePageRouter host={host} onSuccessLogin={onSuccessLogin}
    />
  );
};

const VoiePageRouter = ({ host, onSuccessLogin }) => {
  return (
    <LoginPage onlogin={onSuccessLogin} host={host} />
  );
};

VOIE.propTypes = {
  host: PropTypes.object.isRequired
};

export default VOIE;